import { Fragment, useRef, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
// Mui
import { Theme, Button, Popover, MenuList, MenuItem } from '@mui/material';
// Icons
import { ArrowDropDown as ArrowDropDownIcon, CloseOutlined as CloseOutlinedIcon } from '@mui/icons-material';

type Props = {
  disableControls: boolean;
}

export default function ChatMessageCoverageButton({ disableControls }: Props) {
  const coverageOptions = [10, 25, 50, 100];

  const { setValue, watch } = useFormContext();

  const anchorRef = useRef<HTMLButtonElement>(null);

  const coverage = watch('question.coverage');

  const percentCoverage = useMemo(() => {
    if ( !coverage ) return null;
    return coverageToPercentage(coverage);
  }, [coverage]);

  const [open, setOpen] = useState(false);

  const handleMenuItemClick = (coverage: number) => () => {
    setValue('question.coverage', percentageToCoverage(coverage));
    setOpen(false);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  const handleCoverageClick = () => {
    // if ( !percentCoverage ) handleToggle();
    if ( !percentCoverage ) {
      setOpen((prevOpen) => !prevOpen);
    } else {
      setValue('question.coverage', null);
    }
  };

  return (
    <Fragment>
      <Button
        ref={anchorRef}
        sx={{
          borderColor: (theme:Theme) => `${theme.palette.primary.light} !important`,
          gap: 1,
          textTransform: 'none',
          '&:hover': {
            borderColor: (theme:Theme) => `${theme.palette.primary.light} !important`
          }
        }}
        disabled={disableControls}
        onClick={handleCoverageClick}
        color={percentCoverage ? 'primary' : 'inherit'}
      >
        {percentCoverage ? `Coverage ${percentCoverage}%` : 'Coverage'}
        {percentCoverage ? <CloseOutlinedIcon fontSize="small" /> : <ArrowDropDownIcon fontSize="small" />}
      </Button>
      <Popover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <MenuList>
          {coverageOptions.map((option) => (
            <MenuItem
              key={option}
              selected={option === percentCoverage}
              onClick={handleMenuItemClick(option)}
            >{`${option}%`}</MenuItem>
          ))}
        </MenuList>
      </Popover>
    </Fragment>
  )
}


const coverageToPercentage = (coverage: number) => {
  return Math.round(coverage * 100);
};

const percentageToCoverage = (percentage: number) => {
  return percentage / 100;
};
